/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from'react';
import { useDispatch, useSelector } from 'react-redux';

import { LineItemType } from '../../../../enums/lineItemType';
import CustomTooltip from '../../elements/customTooltip';
import { currencyFormatter } from '../../../../utils/currency';
import { EditModal } from '../edit-modal';
import PromoCouponGreen from '../../../../assets/icons/promo-coupon-green';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit-icon.svg';
import { ReactComponent as QuestionMarkTooltip } from '../../../../assets/icons/question-tooltip-new.svg';
import { ReactComponent as DropdownArrow } from '../../../../assets/icons/arrow.svg';
import { ReactComponent as Warning } from "../../../../assets/icons/FilledWarningLogo.svg";
import { ReactComponent as RedWarning } from "../../../../assets/icons/red-warning.svg";

import "./index.scss";
import i18n from '../../../../utils/translations/i18n';
import { config } from '../../../../utils/config';
import { RootState } from '../../../../store';
import { customQtyApi } from '../../../../store/customQty';
import { get as getStorage ,set as setStorage } from '../../../../utils/storage/localStorage';
import { get as getCookie, delete_cookie, setCookieForSession } from "../../../../utils/cookies";

import CustomAccordion from '../../elements/accordian';
import cartActions from '../../../../store/cartActions';
import { ReOrder } from '../../../../enums/reOrder';

import { cartInteractionEvent } from '../../../../utils/analytics/google';
import { CartInteraction } from '../../../../enums/cartInteraction';
import { TooltipPlacement } from '../../../../enums/tooltip';
import Free from '../../../../models/freeItem';
import { setCheckOOSStatus } from '../../../../store/application';
import { hasLineItem } from '../../../../utils/cart';
import PCCBanner from '../pcc-banner';
import ViewSimilarModal from '../view-similar-modal';

declare const window: any;

const ItemPriceDetails = ({ cart, lineItemId, isMobile = false}: {cart: any, lineItemId: string, isMobile: boolean}) => {

    const dispatch = useDispatch();
    const { t } = i18n;

    const [isOpen, setIsOpen] = useState(false);
    const [isViewSimilarOpen, setIsViewSimilarOpen] = useState(false);
    const [isAccordianOpen, setIsAccordianOpen] = useState(false);
    const [customQtyCall, setCustomQtyCall] = useState(0);
    const [showCustomQty, setShowCustomQty] = useState(false);
    const [isLineItemsRemovedArray, setIsLineItemsRemovedArray] = useState('');
    const [hasRemoveSizes, setHasRemoveSizes] = useState(false);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const containerId = `view-similar-cart-page-placement-${lineItemId}`;

    const toggleModal = () => {
        setIsOpen(!isOpen)
    };
    const {
        applicationState: { currentPage }
      } = useSelector((state: RootState) => state);
    
    const mainItem: any = cart?.lineItems[lineItemId]?.[0].data ?? {};

    useEffect(()=>{
        const fetchData = async () => {
          const showCustomQtySlider: any = await dispatch(customQtyApi.endpoints.getCustomQty.initiate({
            productKey: mainItem.productKey,
            locale: config('locale')
          }));
          if(showCustomQtySlider?.data) setShowCustomQty(showCustomQtySlider?.data?.supportCustomQty);
          if(showCustomQtySlider?.data?.supportCustomQty) {
            const gaSlideInfo = getStorage('qty-select-type')? getStorage('qty-select-type'):{};
            if (!(mainItem.id in gaSlideInfo)) {
                gaSlideInfo[mainItem.id] = {
                    productKey: mainItem.productKey,
                    qtySelectType: "value_not_set"
                };
                setStorage('qty-select-type', gaSlideInfo);
            }
        }
          setCustomQtyCall(1);
        }

        if (customQtyCall === 0) {
          fetchData();
        }
    }, [mainItem.productKey]);

    useEffect(()=>{
        setIsLineItemsRemovedArray(getCookie('np.isLineItemsRemoved'));
        if(isLineItemsRemovedArray){
            const parsedArray = JSON.parse(isLineItemsRemovedArray);
            setHasRemoveSizes(hasLineItem(lineItemId, parsedArray) as boolean);
        } else {
            setHasRemoveSizes(false);
        }
    },[isLineItemsRemovedArray, lineItemId]);

    if(Object.keys(mainItem).length === 0 ) return <></>;

    const upsell: any = cart?.lineItems[mainItem.id].filter(lineitem => lineitem?.type === LineItemType.UPSELL);
    const accessory: any = cart?.lineItems[mainItem.id].filter(lineitem => lineitem?.type === LineItemType.ACCESSORY);
    const freeItem: Free = cart?.lineItems[lineItemId]?.find( item => item.type === LineItemType.FREE)?.data ?? {};
    const additionalCharge: any = cart?.lineItems[mainItem.id].filter(lineitem => lineitem?.type === LineItemType.ADDITIONALCHARGE);

    const showEditImprint = () => {
        const isNotReorderable = mainItem.customfield?.lineItemOrderType !== ReOrder.REORDER_LINEITEM_ORDERTYPE;
        const isUsgProduct = mainItem.customizationInfo?.isUsgUIProduct;
        const isMultiSelectAbsent = !mainItem.multiSelectData?.isExist;
        
        // First condition: Assorted design with specific checks
        if (mainItem.customizationInfo?.isAssortedDesign && isMultiSelectAbsent && isUsgProduct && isNotReorderable) {
            return true;
        }

        // Second condition: V2 and non-V2 products
        if (isUsgProduct && isNotReorderable && (mainItem.isV2Product || isMultiSelectAbsent)) {
            return true;
        }

        return false;
    };

    const returnDiscountRow = ({ totalDiscount, fractionDigits, validDiscountCode }) => {
        return (
            <div className="discount-breakup-row">
                <div className='lineitem-discount'>
                    <PromoCouponGreen width={11} height={12} />
                    <span className='lineitem-discount-code'>{validDiscountCode}</span>
                </div>
                <div className='lineitem-discount'>
                    <span className="">
                        <span className="">- {currencyFormatter(totalDiscount, fractionDigits)}</span>
                    </span>
                </div>
            </div>
        );
    }

    const handleQuantityClick = (event) => {
        event.stopPropagation(); // Stop the click from propagating to the accordion
        // Open the quantity edit modal or other actions here
        if(!isOpen) cartInteractionEvent(CartInteraction.EDIT_QUANTITY,mainItem?.webCode || mainItem?.productFamilyName)
        setIsOpen(!isOpen)
        dispatch(setCheckOOSStatus(true));

        if (isLineItemsRemovedArray) {
            const parsedArray = JSON.parse(isLineItemsRemovedArray);
            const updatedArray = parsedArray.filter(obj => obj.lineItemId !== lineItemId);
            if (updatedArray.length === 0) {
                delete_cookie('np.isLineItemsRemoved');
                setIsLineItemsRemovedArray('');
            } else {
                setCookieForSession('np.isLineItemsRemoved', JSON.stringify(updatedArray), '/');
                setIsLineItemsRemovedArray(JSON.stringify(updatedArray));
            }
        }
    };

    const handleToggleAccordion = () => {
        if (!isAccordianOpen) {
            cartInteractionEvent(
                CartInteraction.PRICE_EXPAND,
                mainItem?.webCode || mainItem?.productFamilyName
            );
        }
        setIsAccordianOpen(!isAccordianOpen);
    };

    const handleRemoveLineitem = () => {
        cartInteractionEvent(
            CartInteraction.CART_REMOVE,
            mainItem?.webCode || mainItem?.productFamilyName
        );
        dispatch(cartActions.removeLineItem(lineItemId, LineItemType.MAINITEM, cart, mainItem?.id))
    }

    const handleViewSimilarClick = () => {
        setIsViewSimilarOpen(true)
        cartInteractionEvent(
            CartInteraction.VIEW_SIMILAR_PRODUCTS,
            mainItem?.webCode || mainItem?.productFamilyName
        );
        const vscontainerId = `#${containerId}`
        window?.np?.CT_UTILS?.productImpressionEvent(vscontainerId);
    }

  const accordianHeadingContent = (
    <div className="item-header">
      <div className="item-quantity" onClick={handleQuantityClick}>
       {t('customer_orders.quantity')}<span className='semi-colon'>:&nbsp;</span>
        <span className="total-quantity">
          {mainItem.totalQuantityWithSubItem}
        </span>
        <EditIcon/>
      </div>
      <>
        {mainItem.totalItemPriceWithLogoWithoutDiscount !== mainItem.totalItemPriceWithLogo ? 
            <div>
                <span className="lineitem-subtotal strike-off">{currencyFormatter(mainItem.totalItemPriceWithLogoWithoutDiscount, cart.fractionDigits)}</span>&nbsp;
                <span className="lineitem-subtotal-discount">{currencyFormatter(mainItem.totalItemPriceWithLogo, cart.fractionDigits)}</span>
            </div> : 
        <span className="lineitem-subtotal">{currencyFormatter(mainItem.totalItemPriceWithLogo, cart.fractionDigits)}</span>}
      </>
    </div>
  );

  const accordianDetailsContent = (
    <div className='lineitem-price-accordian'>
        <div className="item-price-details">
            <div className='item-price-row'>
                <span>{t('shopping_cart_details.item_total')} {mainItem.totalQuantityWithSubItem} x {t('shopping_cart_details.each')?.replace('[X]', `${currencyFormatter(mainItem.unitPrice, cart.fractionDigits)}`)}
                </span>
                {mainItem.totalPriceWithSubItem !== mainItem.totalBasePriceWithSubItem ? 
                    <div>
                        <span className="strike-out">{currencyFormatter(mainItem.totalBasePriceWithSubItem, cart.fractionDigits)}</span>&nbsp;
                        <span className="green-text">{currencyFormatter(mainItem.totalPriceWithSubItem, cart.fractionDigits)}</span>
                    </div> :
                <span>{currencyFormatter(mainItem.totalPriceWithSubItem, cart.fractionDigits)}</span>
                }
            </div>
            {cart.validDiscountCode && mainItem.totalDiscountWithSubItem > 0 && returnDiscountRow({ totalDiscount: mainItem.totalDiscountWithSubItem, fractionDigits: cart.fractionDigits, validDiscountCode: cart.validDiscountCode })}
        </div>

        {Object.keys(freeItem).length > 0 &&
            <div className="item-price-details">
                <div className='item-price-row'>
                    <span>
                        <span className='special-offer'>{t('product_details.extra_free')}</span>
                        :&nbsp;{freeItem.quantity} x {t('shopping_cart_details.each')?.replace('[X]', `${currencyFormatter(0, cart.fractionDigits)}`)}
                    </span>
                    <span>
                        {currencyFormatter(0, cart.fractionDigits)}
                    </span>
                </div>
            </div>
        }
            
        {upsell.length > 0 &&
            React.Children.toArray(upsell.map(({data}) => {
                return (
                    <div className="item-price-details" key={data.id}>
                        <div className='item-price-row'>
                            <span>
                                <span className='special-offer'>{t('shopping_cart_details.special_offer')}</span>
                                :&nbsp;{data.quantity} x {t('shopping_cart_details.each')?.replace('[X]', `${currencyFormatter(data.unitPrice, cart.fractionDigits)}`)}
                            </span>
                            <span>
                                { data.totalBasePrice !== data.totalPriceWithoutAnyCharges ? 
                                    <>
                                        <span className="strike-out">{currencyFormatter(data.totalBasePrice, cart.fractionDigits)}</span>&nbsp;
                                        <span className="coupon-color-discount">{currencyFormatter(data.totalPriceWithoutAnyCharges, cart.fractionDigits)} </span>
                                    </> 
                                    : currencyFormatter(data.totalPriceWithoutAnyCharges, cart.fractionDigits)
                                }
                            </span>
                        </div>
                        {cart.validDiscountCode && upsell[0].data.totalDiscount > 0 && returnDiscountRow({ totalDiscount: upsell[0].data.totalDiscount, fractionDigits: cart.fractionDigits, validDiscountCode: cart.validDiscountCode })}
                    </div>
                )
            }))
        }
            
        {accessory.length > 0 && (
            <>
                {React.Children.toArray(
                    accessory.map(({ data }, index) => {
                        const isLastItem = index === accessory.length - 1;
                        return (
                            <div className="item-price-details" key={data.id}>
                                <div className="item-price-row">
                                    <span>
                                        <span className="accessory-name">{data.name}</span>
                                        :&nbsp;{data.quantity} x {t('shopping_cart_details.each')?.replace('[X]', `${currencyFormatter(data.unitPrice, cart.fractionDigits)}`)}
                                    </span>
                                    <span>
                                        { data.totalBasePrice !== data.totalPriceWithoutAnyCharges ? 
                                            <>
                                                <span className="strike-out">{currencyFormatter(data.totalBasePrice, cart.fractionDigits)}</span>&nbsp;
                                                <span className="coupon-color-discount">{currencyFormatter(data.totalPriceWithoutAnyCharges, cart.fractionDigits)}</span>
                                            </> 
                                            : currencyFormatter(data.totalPriceWithoutAnyCharges, cart.fractionDigits)
                                        }
                                    </span>
                                </div>
                                {isLastItem && cart.validDiscountCode && data.totalDiscount > 0 && (
                                    returnDiscountRow({
                                        totalDiscount: data.totalDiscount,
                                        fractionDigits: cart.fractionDigits,
                                        validDiscountCode: cart.validDiscountCode,
                                    })
                                )}
                            </div>
                        );
                    })
                )}
            </>
        )}

        {additionalCharge.length > 0 &&  
            React.Children.toArray(additionalCharge.map(({data}, index)=>{ //eslint-disable-line
                if(data.appliedInCart){
                    const isLastItem = index === additionalCharge.length - 1;
                    return (
                        <div className="item-price-details" key={data.id}>
                            <div className='item-price-row'>
                                <span className=" additional-charge-tooltip">
                                    {data.name} {data.description &&  <CustomTooltip content={data.description} placement={TooltipPlacement.TOP}><QuestionMarkTooltip/></CustomTooltip>}
                                </span>
                                <span>
                                    {currencyFormatter(data.value, cart.fractionDigits)}
                                </span>
                            </div>
                            {isLastItem && cart.validDiscountCode && additionalCharge[0].data.totalDiscount > 0 && returnDiscountRow({ totalDiscount: additionalCharge[0].data.totalDiscount, fractionDigits: cart.fractionDigits, validDiscountCode: cart.validDiscountCode })}
                        </div>
                    )
                }
            }))
        }

        {mainItem.itemImportCharge > 0 && config('locale') === 'en-US' &&
            <div className="item-price-details import-charge">
                <div className="item-price-row">
                    <span>
                        {t('import_charge_title')}
                        <CustomTooltip
                            content={t('import_charge_description')}
                            placement={TooltipPlacement.TOP}
                            >
                                <QuestionMarkTooltip/>
                        </CustomTooltip>
                    </span>
                    <span>{currencyFormatter(mainItem.itemImportCharge, cart.fractionDigits)}</span>
                </div>
            </div>
        }

        {mainItem.setupChargeAdded &&
            <div className="item-price-details">
                <div className="item-price-row">
                    <span>
                        {config("setupChargeHeading") ?? t('shopping_cart_details.setup')}
                        <CustomTooltip
                            content={config("setupChargeTooltip") ?? t('shopping_cart_details.setup_title')}
                            placement={TooltipPlacement.TOP}
                            >
                                <QuestionMarkTooltip/>
                        </CustomTooltip>
                    </span>
                    <span>
                        {(mainItem.itemSetupChargeWithGlobalDiscount !== mainItem.lineItemSetupCharge) &&
                            <span>
                                <span className="strike-out">{currencyFormatter(mainItem.lineItemSetupCharge, cart.fractionDigits)}</span>&nbsp;
                                {mainItem.itemSetupChargeWithGlobalDiscount === 'Free' && <span className='coupon-color-discount'>{t('order_details.free')} </span>}
                                {mainItem.itemSetupChargeWithGlobalDiscount !== 'Free' && <span className='coupon-color-discount'>{currencyFormatter(mainItem.itemSetupChargeWithGlobalDiscount, cart.fractionDigits)}</span>}
                            </span>
                        }
                        {mainItem.itemSetupChargeWithGlobalDiscount === mainItem.lineItemSetupCharge &&
                            <span>{currencyFormatter(mainItem.itemSetupChargeWithGlobalDiscount, cart.fractionDigits)}</span>
                        }
                    </span>
                </div>
                {cart.validDiscountCode && mainItem.lineItemSetupDiscount > 0 && returnDiscountRow({ totalDiscount: mainItem.lineItemSetupDiscount, fractionDigits: cart.fractionDigits, validDiscountCode: cart.validDiscountCode })}
            </div>
        }
            
        {mainItem.logoChargeApplicable && mainItem.logoImprintAdded &&
            <div className="item-price-details">
                <div className="item-price-row">
                    <span>
                        {t('shopping_cart_details.logoImprint')}
                    </span>
                    <span>
                        {(mainItem.itemLogoChargeWithGlobalDiscount !== mainItem.itemLogoCharge) &&
                            <span>
                                <span className="strike-out">{currencyFormatter(mainItem.itemLogoCharge, cart.fractionDigits)}</span>&nbsp;
                                {mainItem.itemLogoChargeWithGlobalDiscount === LineItemType.FREE && <span className='coupon-color-discount'>{t('order_details.free')} </span>}
                                {mainItem.itemLogoChargeWithGlobalDiscount !== LineItemType.FREE && <span className='coupon-color-discount'>{currencyFormatter(mainItem.itemLogoChargeWithGlobalDiscount, cart.fractionDigits)}</span>}
                            </span>  
                        }
                        {mainItem.itemLogoChargeWithGlobalDiscount === mainItem.itemLogoCharge &&
                            <span>{currencyFormatter(mainItem.itemLogoChargeWithGlobalDiscount, cart.fractionDigits)}</span>
                        }
                    </span>
                </div>
                {cart.validDiscountCode && mainItem.itemLogoDiscount > 0 && returnDiscountRow({ totalDiscount: mainItem.itemLogoDiscount, fractionDigits: cart.fractionDigits, validDiscountCode: cart.validDiscountCode })}
            </div>
        }
    </div>
  );

    return (
        <>
            <div className={`shopping-bag-lineitem-details ${mainItem.isOutOfStock ? 'zeroMargin': ''} ${(mainItem.isV2Product && mainItem.isImprintOverflow) ? 'hasImprintOverflow' : ''}`}>
                <div>
                    {mainItem.isBelowMOQ && !mainItem.isOutOfStock &&
                        <div className='moq-alert-message'>
                            <RedWarning />
                            <span>{t('moq.lineItem_warning')}&nbsp;<span className='viewSimilarLink' onClick={handleQuantityClick} >{t('moq.edit_qantity_link_text')}</span></span>
                        </div>
                    }
                    {mainItem.isOutOfStock ?
                        <div className='oos-alert-message'>
                            <RedWarning />
                            <span>{t('oos.item_out_of_stock')} &nbsp; <span className='viewSimilarLink' onClick={handleViewSimilarClick}>{t('oos.view_similar')}</span></span>
                        </div> :
                        <span>
                            {mainItem?.multiSelectData?.isExist && hasRemoveSizes &&
                                <div className='oos-item-removed-warning'>
                                    <Warning />
                                    <span>{t('oos.one_or_more_items_removed_from_cart')}</span>
                                </div>
                            }
                            <CustomAccordion isExpanded={isAccordianOpen} toggleAccordion={handleToggleAccordion} customClass={'price-details'} expandIcon = {<DropdownArrow/>}>  
                                {accordianHeadingContent}
                                {accordianDetailsContent}
                            </CustomAccordion>

                            {!isMobile && mainItem.postCheckOutCustomization && <PCCBanner
                                className="shopping-bag-pcc-banner"
                                />}
                        </span>
                    }
                </div>
                {mainItem.isV2Product && mainItem.isImprintOverflow &&
                    <div className="imprint-overflow-warning">
                        <Warning />
                        <span>{t('shopping_cart_details.imprint_overflow_warning')}</span>
                    </div>
                }
            
                <div className='actions-row'>
                    {showEditImprint() && !mainItem.isOutOfStock &&
                        <>
                            <span className='actions-text' data-testid='edit-design' onClick={() => cartActions.editImprint(mainItem, cart.id)}>
                                {t('customize.edit_design')}
                            </span>
                            <span className="divider"></span>
                        </>
                    }
                    
                    <span className='actions-text' data-testid='remove-lineitem' onClick={handleRemoveLineitem}>
                        {t('shopping_cart_details.removeButton')}
                    </span>

                </div>

                <EditModal
                    cart={cart}
                    lineItemId={lineItemId}
                    isOpen={isOpen}
                    toggleModal={toggleModal}
                    showCustomQtySlider={showCustomQty}
                />
                {mainItem.isOutOfStock && <ViewSimilarModal
                    isViewSimilarOpen={isViewSimilarOpen}
                    setIsViewSimilarOpen={setIsViewSimilarOpen}
                    closeModal={() => setIsViewSimilarOpen(false)}
                    lineItemId={lineItemId}
                    webCode={mainItem.webCode}
                    isMobile={isMobile}
                    containerRef={containerRef}
                    containerId={containerId}
                />}
            </div>
        </>
    )
}
export default ItemPriceDetails;